import PropTypes from 'prop-types';

import AlertWarning from '../../shared/alertWarning.component';

const MultipleCurrenciesWarning = ({
  hasDifferentCurrencies = false,
}) => AlertWarning({
  warningMessage: '*These values contain multiple currencies. Data might not be consistent.',
  show: hasDifferentCurrencies,
});

MultipleCurrenciesWarning.propTypes = {
  hasDifferentCurrencies: PropTypes.bool,
};

export default MultipleCurrenciesWarning;
